// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"135":"doatahlil","177":"home","314":"setting","401":"yasin","443":"about","609":"team","631":"contact","910":"tahlil"}[chunkId] + "." + {"135":"1f5dfca4","177":"008ab039","314":"79103c3e","401":"747d20da","443":"b450e978","609":"e2c0559d","631":"dbf71de6","910":"c7536909"}[chunkId] + ".css";
};